export const saveNotes = state => {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem('state', serializedState)
  } catch (err) {
    console.log('Something bad happened', err)
  }
}

export const loadNotes = () => {
  try {
    const serializedState = localStorage.getItem('state')
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    return undefined
  }
}



// WEBPACK FOOTER //
// ./src/LocalStorage/localstorage.js